import React from "react";

function ZoomControls({ zoomAll, isZoomAll, zoomIn, zoomOut }) {
  return (
    <div style={{ padding: 2, paddingBottom: 0, backgroundColor: "white" }}>
      <img
        className="clickable"
        onClick={zoomAll}
        style={{ margin: 2 }}
        height="24"
        width="24"
        src={`/orgchart/icons/zoom-all${isZoomAll ? "-green" : ""}.svg`}
        alt="Zoom All"
      />
      <img
        className="clickable"
        onClick={zoomIn}
        style={{ margin: 2 }}
        height="24"
        width="24"
        src="/orgchart/icons/zoom-in.svg"
        alt="Zoom in"
      />
      <img
        className="clickable"
        onClick={zoomOut}
        style={{ margin: 2 }}
        height="24"
        width="24"
        src="/orgchart/icons/zoom-out.svg"
        alt="Zoom out"
      />
    </div>
  );
}

export default ZoomControls;
